define('plugin/push-notifications/view/PushMessageView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');
    /**
     *
     * @class TelegramNotificationsView
     */
    return LayoutView.extend({

        template: '#push_message_view',

        ui: {
            // pushSuccessBlock: '.push-success'
        },

        modelEvents: {
            'sync': 'render',
            'change': 'render'
        },

        initialize: function () {
            this._clientModel = this.getOption('clientModel');
            LayoutView.prototype.initialize.apply(this);
        },


        onBeforeShow : function () {
            //console.log(this.ui.subscribeBtn);
        },


        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);

            return data;
        },

    });

});
